export const createURL = ({
  startDate = '',
  endDate = '',
  organizationId = '',
  queryParameter = ''
}) => {
  const stringParams = new URLSearchParams();

  if (queryParameter) {
    stringParams.append('queryParameter', String(queryParameter).trim());
  }

  if (startDate) {
    stringParams.append('startDate', startDate);
  }

  if (endDate) {
    stringParams.append('endDate', endDate);
  }

  if (organizationId) {
    stringParams.append('organizationId', organizationId);
  }

  return `?${stringParams.toString()}`;
};

export function getSearchParams() {
  const params = new URL(window.location.href.replace('#/', '')).searchParams;
  const startDate = params.get('startDate') || '';
  const endDate = params.get('endDate') || '';
  const organizationId = params.get('organizationId') || '';
  const queryParameter = params.get('queryParameter') || '';

  return {
    startDate,
    endDate,
    organizationId,
    queryParameter
  };
}
